module.exports = __webpack_public_path__ + "img/online_make.2085b6ee.svg";